import React, {useEffect, useState} from "react";
import Header from "../../components/Header";
import "./style.scss";
import {useTranslation} from "react-i18next";
import {PaymentMethod} from "../../@types/enums/PaymentType";
import {ReactComponent as IconCard} from "../../assets/icons/card.svg";
import {ReactComponent as IconSwish} from "../../assets/icons/swish.svg";
import {ReactComponent as IconVipps} from "../../assets/icons/vipps.svg";
import {ReactComponent as IconGiftCard} from "../../assets/icons/giftCard.svg";
import {ReactComponent as IconCheck} from "../../assets/icons/check.svg";
import orderStore from "../../stores/order";
import {observer} from "mobx-react";
import FooterOrder from "../../components/FooterOrder";
import OrderIdle from "../../components/OrderIdle";
import {hideLoader, showLoader} from "../../helpers/ComponentHelper";
import {addToLog} from "../../helpers/ApiHelper";
import {CashRegisterPaymentMethod} from "../../@types/api/payment";

const PaymentMethodPage = () => {
    const [t] = useTranslation();

    const [paymentMethodId, setPaymentMethodId] = useState<number>(orderStore.paymentMethodId);
    const [terminalId, setTerminalId] = useState<string | undefined>(orderStore.terminalId);

    useEffect(() => {
        setPaymentMethodId(orderStore.paymentMethodId);
    }, [orderStore.paymentMethodId]);

    useEffect(() => {
        setTerminalId(orderStore.terminalId);
    }, [orderStore.terminalId]);

    useEffect(() => {
        orderStore.internalCard = "";
        getPaymentMethods();
    }, []);

    useEffect(() => {
        orderStore.paymentMethodId = paymentMethodId;
    }, [paymentMethodId]);

    useEffect(() => {
        orderStore.terminalId = terminalId;
    }, [terminalId]);

    const getPaymentMethodIcon = (type: PaymentMethod) => {
        switch(type) {
            case PaymentMethod.CARD:
                return <IconCard className="paymentMethodIcon card" />;
            case PaymentMethod.GIFT_CARD:
                return <IconGiftCard className="paymentMethodIcon giftCard" />;
            case PaymentMethod.VIPPS:
                return <IconVipps className="paymentMethodIcon vipps" />;
            case PaymentMethod.SWISH:
                return <IconSwish className="paymentMethodIcon swish" />;
        }
    }

    const getPaymentMethods = async () => {
        showLoader()
        await orderStore.getAllowedPaymentMethods();
        hideLoader();
    }

    const changePaymentMethod = (paymentMethod: CashRegisterPaymentMethod) => {
        addToLog(`Change payment method to #${paymentMethod.id} / ${paymentMethod.name}`);
        setPaymentMethodId(paymentMethod.id);
        setTerminalId(paymentMethod.terminalId)
    }

    return <div className="PaymentMethodPage">
        <Header />
        <h2>{t('choosePaymentMethod')}</h2>
        <div className="paymentMethods">
            {orderStore.allowedPaymentMethods.map(x => {
                const methods = [];
                const origPaymentMethodName: any[] = [x.name];
                if (orderStore.internalCardObj && orderStore.internalCardObj.balance > 0 && x.id === orderStore.internalCardObj?.paymentMethodId) {
                    origPaymentMethodName.push(<br/>);
                    origPaymentMethodName.push(`(${t("anotherCard")})`);
                    methods.push(<div key={`paymentType_${orderStore.internalCardObj.paymentMethodId}_current`} className={`paymentMethod ${orderStore.internalCardObj.paymentMethodId === paymentMethodId && terminalId === "internalCard" ? "active" : ""}`} onClick={() => {changePaymentMethod({
                        type: PaymentMethod.GIFT_CARD,
                        id: orderStore.internalCardObj?.paymentMethodId || -1,
                        name: orderStore.getPaymentMethod()?.name || "",
                        terminalId: "internalCard"
                    })}}>
                        <div className="left">{getPaymentMethodIcon(PaymentMethod.GIFT_CARD)}</div>
                        <div className="center">
                            {x.name}
                            <br />
                            {orderStore.internalCardObj.cardNumber} ({t("cardBalance")}: {orderStore.internalCardObj?.balance})</div>
                        <div className="right">
                            {orderStore.internalCardObj?.paymentMethodId === paymentMethodId && terminalId === "internalCard"
                                ? <IconCheck className="check" />
                                : null
                            }
                        </div>
                    </div>);
                }

                methods.push(<div key={`paymentType_${x.id}`}
                     className={`paymentMethod ${x.id === paymentMethodId && x.terminalId === terminalId ? "active" : ""}`}
                     onClick={() => {
                         changePaymentMethod(x)
                     }}>
                    <div className="left">{getPaymentMethodIcon(x.type)}</div>
                    <div className="center">{origPaymentMethodName}</div>
                    <div className="right">
                        {x.id === paymentMethodId && x.terminalId === terminalId
                            ? <IconCheck className="check"/>
                            : null
                        }
                    </div>
                </div>);

                return methods;
            })}
        </div>
        <FooterOrder isFinalize={true} />
        <OrderIdle />
    </div>
}

export default observer(PaymentMethodPage);
